import { FormGroup } from "@angular/forms";
import {
    CODE_COLUMN_NAME,
    DESCRIPTION_IMPORT_FIELD,
    EImportMode, HOST_COLUMN_NAME,
    IFieldConfig,
    WORDING_IMPORT_FIELD
} from "app_sasha/pages/import-booking/config/import-booking.interface";
import { Injectable } from "@angular/core";
import { Required } from "libraries/module/formbuilder/forms/utils/validators/required.validator";
import { Yii } from "libraries/interfaces/Yii";
import { IBookingHostCode } from "libraries/service/resources/booking/interfaces/import.interface";
import { IHostCodesAndAliases } from "libraries/service/resources/host-alias/host-alias.resource";

@Injectable()
export class ImportBookingFieldsetService {
    public initFieldConfig(formGroup: FormGroup, mode: EImportMode): IFieldConfig {
        switch (mode) {
            case EImportMode.simple:
                return {
                    hostName: {
                        config: {
                            formGroup,
                            formControlName: 'hostName',
                            label: WORDING_IMPORT_FIELD.hostName,
                            description: DESCRIPTION_IMPORT_FIELD.hostName,
                            validators: [new Required()],
                        },
                        items: []
                    },
                    bookingCode : {
                        config: {
                            formGroup,
                            formControlName: 'bookingCode',
                            label: WORDING_IMPORT_FIELD.bookingCode,
                            description: DESCRIPTION_IMPORT_FIELD.bookingCode,
                            validators: [new Required()]
                        }
                    },
                };
            case EImportMode.multiple:
                return {
                    text: {
                        config: {
                            formGroup,
                            formControlName: 'text',
                            label: WORDING_IMPORT_FIELD.multipleImport,
                            description: DESCRIPTION_IMPORT_FIELD.multipleImport,
                            validators: [new Required()]
                        }
                    },
                };
            default:
                return null;
        }
    }

    public valueSplitter(value: string[], hostCodesAndAliases: IHostCodesAndAliases = null): IBookingHostCode[] {
        for(let i: number=value.length-1; i >= 0 ; i--){
            if(value[i].replace(' ', '') === '') {
                value.splice(i, 1);
            }
        }

        return value.map((text: string) => {
            if (/\s/.test(text)){
                const table: string[] = text.split(' ');
                return {host: getHostCode(table[0], hostCodesAndAliases), code: table[1]};
            }
            if(text.includes('.')){
                const table: string[] = text.split('.');
                return {host: getHostCode(table[0], hostCodesAndAliases), code: table[1]};
            }
            if(text.includes('/')){
                const table: string[] = text.split('/');
                return {host: getHostCode(table[0], hostCodesAndAliases), code: table[1]};
            }
            if(text.includes(',')){
                const table: string[] = text.split(',');
                return {host: getHostCode(table[0], hostCodesAndAliases), code: table[1]};
            }
        });
    }

    public readFile(value: string): {text: string[]} {
        const textFromFileLoaded: string = value;
        const text: string[] = textFromFileLoaded.split('\n');
        return {
            text
        };
    }
}

function getHostCode(hostName: string, hostCodesAndAliases: IHostCodesAndAliases = null): string {
    if (!hostCodesAndAliases || !hostCodesAndAliases.aliases || !hostCodesAndAliases.codes) {
        return hostName;
    }
    const aliasIndex: number = hostCodesAndAliases.aliases.indexOf(hostName);
    return aliasIndex >= 0 ? hostCodesAndAliases.codes[aliasIndex] : hostName;
}
